module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lee-status-card"
  }, [_c('div', {
    staticClass: "symbol",
    class: [_vm.type]
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca360ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/status_card.vue
// module id = 604
// module chunks = 1